export function useBrowserHistoryData() {
  function setBrowserHistory() {
    const currentPathname = sessionStorage.getItem('currentPathname')
    sessionStorage.setItem('previousPathname', currentPathname ?? '')
    sessionStorage.setItem('currentPathname', window.location.href)
  }
  return {
    setBrowserHistory,
  }
}
